import { Dialog as DialogPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const SheetClose = (props: ComponentProps<typeof DialogPrimitive.Close>) => (
  <DialogPrimitive.Close data-slot="sheet-close" {...props} />
);
